const rootSelector = '.wp-block-wps-blocks-catalog';

document.querySelectorAll(rootSelector).forEach((root) => {
	if (!(root instanceof HTMLElement)) {
		return;
	}

	const visual = root.querySelector('[data-catalog-visual]');
	const image = root.querySelector('[data-catalog-image]');
	const list = root.querySelector('[data-catalog-list]');
	const items = root.querySelectorAll('[data-catalog-item]');

	if (!(image instanceof HTMLElement) || !items.length) {
		return;
	}

	const defaultImage =
		visual instanceof HTMLElement ? visual.dataset.defaultImage || '' : '';

	const setImage = (url) => {
		if (!url) {
			image.style.backgroundImage = '';
			return;
		}
		image.style.backgroundImage = `url("${url}")`;
	};

	const activate = (target) => {
		items.forEach((node) => {
			if (node instanceof HTMLElement) {
				node.classList.toggle('is-active', node === target);
			}
		});
	};

	const firstItem = items[0] instanceof HTMLElement ? items[0] : null;

	items.forEach((item) => {
		if (!(item instanceof HTMLElement)) {
			return;
		}

		item.addEventListener('mouseenter', () => {
			activate(item);
			setImage(item.dataset.imageUrl || defaultImage);
		});

		item.addEventListener('focusin', () => {
			activate(item);
			setImage(item.dataset.imageUrl || defaultImage);
		});
	});

	if (list instanceof HTMLElement) {
		list.addEventListener('mouseleave', () => {
			// if (firstItem) {
			// 	activate(firstItem);
			// }
			// setImage(defaultImage);
		});
	}
});
